// apps/cli/src/templates/dockerfile.ts

export const dockerfileTemplate = (
  agentName: string,
) => `# raxd — Reactive Agents Daemon
# Generated by: rax deploy init
# Agent: ${agentName}

# ── Stage 1: Dependencies ────────────────────────────────────────────────────
FROM oven/bun:1-alpine AS deps

WORKDIR /app
COPY package.json bun.lock* ./
RUN bun install --frozen-lockfile --production 2>/dev/null || bun install --production

# ── Stage 2: Build ───────────────────────────────────────────────────────────
FROM oven/bun:1-alpine AS build

WORKDIR /app
COPY --from=deps /app/node_modules ./node_modules
COPY . .
RUN bun build src/index.ts --target=bun --outdir=dist

# ── Stage 3: Runtime ─────────────────────────────────────────────────────────
FROM oven/bun:1-alpine

# Hardening: non-root user
RUN addgroup -g 1001 -S raxd && \\
    adduser -S raxd -u 1001 -G raxd && \\
    mkdir -p /app/data && chown -R raxd:raxd /app

WORKDIR /app

COPY --from=deps --chown=raxd:raxd /app/node_modules ./node_modules
COPY --from=build --chown=raxd:raxd /app/dist ./dist

USER raxd

HEALTHCHECK --interval=30s --timeout=5s --start-period=10s --retries=3 \\
  CMD wget -qO- http://localhost:3000/health || exit 1

STOPSIGNAL SIGTERM
EXPOSE 3000

ENTRYPOINT ["bun", "run", "dist/index.js"]
`;

/** Monorepo-aware Dockerfile. Build context = workspace root. Runs TS directly (no bundling). */
export const dockerfileMonorepoTemplate = (
  agentName: string,
  appPath: string,
) => `# raxd — Reactive Agents Daemon (monorepo)
# Generated by: rax deploy init
# Agent: ${agentName}
# Build context: workspace root (../../)

# ── Stage 1: Install + build workspace packages ─────────────────────────────
FROM oven/bun:1-alpine AS build

WORKDIR /app
COPY package.json bun.lock tsup.config.base.ts tsconfig.json ./
COPY packages/ packages/
COPY ${appPath}/ ${appPath}/
RUN bun install --frozen-lockfile 2>/dev/null || bun install
RUN bun run build:packages

# ── Stage 2: Runtime ─────────────────────────────────────────────────────────
FROM oven/bun:1-alpine

# Hardening: non-root user
RUN addgroup -g 1001 -S raxd && \\
    adduser -S raxd -u 1001 -G raxd && \\
    mkdir -p /app/data /app/${appPath}/drafts && chown -R raxd:raxd /app

WORKDIR /app

COPY --from=build --chown=raxd:raxd /app/node_modules ./node_modules
COPY --from=build --chown=raxd:raxd /app/packages/ ./packages/
COPY --from=build --chown=raxd:raxd /app/${appPath}/ ./${appPath}/
COPY --from=build --chown=raxd:raxd /app/package.json ./package.json

USER raxd

HEALTHCHECK --interval=30s --timeout=5s --start-period=10s --retries=3 \\
  CMD wget -qO- http://localhost:3000/health || exit 1

STOPSIGNAL SIGTERM
EXPOSE 3000

ENTRYPOINT ["bun", "run", "${appPath}/src/index.ts"]
`;
